import { render, staticRenderFns } from "./BirthConsultation.vue?vue&type=template&id=1f49de97&"
import script from "./BirthConsultation.vue?vue&type=script&lang=js&"
export * from "./BirthConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports